<ng-container *appTranslate="let t">
  @if (form) {
    <form class="dialog-form" [formGroup]="form" (ngSubmit)="saved.emit(form.value)">
      <p class="text-text-subtle-text">
        {{ t("userFeedback.text") }}
      </p>

      <p-card>
        <div class="dialog-form">
          <div class="flex justify-between">
            <label class="text-table-heading">
              {{ t("userFeedback.overallRating") }}
            </label>

            <p-rating formControlName="overallRating" />
          </div>

          <div class="flex justify-between">
            <label class="text-table-heading">
              {{ t("userFeedback.usabilityRating") }}
            </label>

            <p-rating formControlName="usabilityRating" />
          </div>

          <div class="flex justify-between">
            <label class="text-table-heading">
              {{ t("userFeedback.functionalityRating") }}
            </label>

            <p-rating formControlName="functionalityRating" />
          </div>

          <div class="flex justify-between">
            <label class="text-table-heading">
              {{ t("userFeedback.performanceRating") }}
            </label>

            <p-rating formControlName="performanceRating" />
          </div>
        </div>
      </p-card>

      <p-floatlabel variant="in">
        <textarea pTextarea formControlName="comment" [rows]="6" [maxlength]="10000" [fluid]="true"></textarea>

        <label>
          {{ t("userFeedback.freeTextTitle") }}
        </label>
      </p-floatlabel>

      <div class="col">
        <new-ui-button
          [fluid]="true"
          [disabled]="!form.valid || !form.dirty || disabled"
          [label]="t('feedback.submit')"
          icon="icon-[mi--checkmark-medium]"
          type="submit"
        />

        <new-ui-button
          [fluid]="true"
          icon="icon-[mi--close-medium]"
          [label]="t('common.cancel')"
          severity="secondary"
          type="reset"
          (onClick)="closed.emit()"
        />
      </div>
    </form>
  }
</ng-container>
